/* @flow */

// eslint-disable-next-line import/no-commonjs
module.exports = require('./dist/zalgo-promise');
